var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconovideolink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_624_17990",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 30,
    height: 30,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_624_17990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6168 15.2481C17.784 15.4324 17.9389 15.6291 18.1183 15.8012C19.9447 17.5464 21.7735 19.2892 23.6024 21.0321C23.799 21.2189 24.0006 21.3983 24.1825 21.5974C24.3865 21.8187 24.3349 22.1161 24.0793 22.2488C24.0129 22.2832 23.9318 22.3005 23.8556 22.3029C23.4377 22.3078 23.0198 22.3054 22.6019 22.3054C22.3045 22.3054 22.0734 22.1603 21.8645 21.9612C21.159 21.2877 20.4535 20.6166 19.7505 19.9431C18.6026 18.8468 17.4521 17.7505 16.3067 16.6492C16.2649 16.6099 16.2354 16.5386 16.2354 16.4821C16.2305 15.6783 16.2305 14.8769 16.2354 14.0731C16.2354 14.0141 16.2698 13.9379 16.314 13.8961C17.5456 12.7138 18.782 11.5363 20.0184 10.3589C20.6256 9.77875 21.2352 9.20109 21.8375 8.61851C22.0906 8.3727 22.3709 8.23012 22.7371 8.25225C23.1083 8.27683 23.4819 8.26454 23.8556 8.25716C24.0522 8.25471 24.1899 8.33828 24.271 8.50544C24.3546 8.6775 24.3079 8.83728 24.18 8.96756C23.9613 9.18879 23.7351 9.40265 23.5114 9.61651C22.4397 10.6391 21.3655 11.6617 20.2913 12.6843C19.4383 13.4979 18.5829 14.3115 17.7299 15.1227C17.6808 15.1694 17.6242 15.2112 17.5726 15.2555C17.5849 15.2555 17.6021 15.2505 17.6168 15.2481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7349 15.2744C12.5013 15.0507 12.2752 14.8344 12.0466 14.6156C10.7536 13.3816 9.45819 12.1477 8.16275 10.9112C7.52856 10.309 6.8919 9.70429 6.2577 9.09959C6.19379 9.03813 6.12988 8.97176 6.07826 8.89802C5.98485 8.76774 5.97502 8.62517 6.05368 8.48259C6.12988 8.34494 6.24541 8.25891 6.40765 8.25891C6.8624 8.25645 7.31716 8.25891 7.77191 8.25891C8.01281 8.25891 8.207 8.37444 8.37169 8.53176C8.85349 8.98159 9.32791 9.43881 9.80478 9.89602C10.9454 10.985 12.0859 12.0715 13.229 13.1604C13.492 13.4111 13.7575 13.6619 14.018 13.9175C14.05 13.9495 14.077 14.006 14.077 14.0527C14.0795 14.8688 14.0819 15.6825 14.077 16.4986C14.077 16.5502 14.0451 16.6165 14.0057 16.6534C12.3735 18.2168 10.7364 19.7777 9.10176 21.3386C8.87315 21.5574 8.64455 21.7737 8.4184 21.9925C8.19471 22.2063 7.9366 22.3194 7.62196 22.312C7.24095 22.3022 6.85994 22.3071 6.47893 22.3096C6.27983 22.312 6.12742 22.2334 6.04139 22.0515C5.95289 21.8671 6.01435 21.7024 6.14954 21.5721C6.5281 21.2034 6.90911 20.8396 7.29257 20.4733C8.27828 19.5319 9.26645 18.5929 10.2546 17.6514C11.056 16.8894 11.8549 16.1249 12.6562 15.3629C12.6783 15.3359 12.7029 15.3088 12.7349 15.2744Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconovideolink);
export default __webpack_public_path__ + "static/media/iconovideolink.d8121005050e9a7a8bba684ce5d05142.svg";
export { ForwardRef as ReactComponent };